
import UnlayerEditor from './UnlayerEditor.vue';
import { STANDARD_FIELDS } from './custom-forms';
import packageFile from '../../package.json';

const { version } = packageFile;

const install = (Vue) => {
    Vue.component('UnlayerEditor', UnlayerEditor);
};

export default {
    install,
};

// Reexport public component
export { UnlayerEditor, STANDARD_FIELDS, version };
